import { PORTAL_TUTORIAL_TARGETS } from './portal-tutorial-targets.const'

export const PORTAL_TUTORIAL_SIDE_NAV_TARGET_BY_ID: Record<string, string> = {
  portal: PORTAL_TUTORIAL_TARGETS.PORTAL_NAV,
  vision: PORTAL_TUTORIAL_TARGETS.VISION_NAV,
  modules: PORTAL_TUTORIAL_TARGETS.MODULES_NAV,
  gateway: PORTAL_TUTORIAL_TARGETS.GATEWAY_NAV,
  insights: PORTAL_TUTORIAL_TARGETS.INSIGHTS_NAV,
  academy: PORTAL_TUTORIAL_TARGETS.ACADEMY_NAV,
}
